<template>
  <SoDialog v-model="value">
    <template #title>
      <MeterpointHeader :meterpoint="meterpoint" />
    </template>
    <SoTabs class="pb-2">
      <SoTab :title="`Industry ${meterpoint.eacOrAq}`" icon="factory">
        <p
          v-for="(register, index) in meterpoint.registers"
          :key="index"
          class="mb-2"
          data-testid="register-industry-usage"
        >
          <span v-if="meterpoint.registers.length > 1">{{
            register.rateName
          }}</span>
          {{ meterpoint.eacOrAq }} {{ register.usage }}kWh
        </p>
      </SoTab>
      <SoTab title="Meter Readings" icon="head">
        <EstimateAnnualConsumption
          v-if="isEstimatorEnabled"
          :meterpoint="meterpoint"
        />
        <template v-else>
          <UsageReadCalculator
            v-for="(register, index) in meterpoint.registers"
            :key="index"
            :meterpoint="meterpoint"
            :register="register"
            class="usage-read-calculator"
          />
        </template>
      </SoTab>
      <SoTab title="Estimate" icon="calculator">
        <UsageEstimator :is-electricity="meterpoint.isElectricity" />
      </SoTab>
    </SoTabs>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import SoTab from "@/components/tabs/SoTab.vue"
  import SoDialog from "@/components/SoDialog.vue"
  import MeterpointHeader from "@/views/customer/components/MeterpointHeader.vue"
  import UsageReadCalculator from "@/views/customer/components/UsageReadCalculator.vue"
  import UsageEstimator from "@/views/customer/components/UsageEstimator/UsageEstimator.vue"
  import EstimateAnnualConsumption from "@/views/customer/meterpoints/components/EstimateReads/EstimateAnnualConsumption.vue"
  import { IMeterpoint } from "@/models/meterpoint/meterpoint.types"
  import { FeaturesService } from "@/services/admin/FeaturesService"
  import { METER_READ_ESTIMATOR_UI_FLAG } from "@/views/customer/meterpoints/components/EstimateReads/estimatorHelper"

  export default defineComponent({
    components: {
      SoDialog,
      SoTabs,
      SoTab,
      EstimateAnnualConsumption,
      MeterpointHeader,
      UsageReadCalculator,
      UsageEstimator,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
      meterpoint: {
        type: Object as PropType<IMeterpoint>,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      /**
       * The estimator replaces this tab's Hasura annual-load-profile maths with
       * the shared service, so Nova stops holding two answers to the same
       * question. The old path stays until SO-32439 retires it.
       */
      isEstimatorEnabled(): boolean {
        return (
          FeaturesService.isFeatureActive(METER_READ_ESTIMATOR_UI_FLAG) ?? false
        )
      },
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>

<style scoped>
  .usage-read-calculator {
    max-width: 300px;
  }
</style>
